import { Inject, Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { isNil, omit } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

import { $frontendTypes } from './Utilities.frontend.types'

@Injectable({ providedIn: 'root' })
export class Utilities_create_awi_configuration_flowService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  async run($inParams: { content: any, filters: { name: string, value: string }[], context: string, scope: string, priority?: number }): Promise<{ config_id?: number, reasons?: string[] }> 
  {
    const $missingRequiredInParams = [];
    if (isNil($inParams.content)) {
      $missingRequiredInParams.push('\'content\'');
    }
    if (isNil($inParams.filters)) {
      $missingRequiredInParams.push('\'filters\'');
    }
    if (isNil($inParams.context)) {
      $missingRequiredInParams.push('\'context\'');
    }
    if (isNil($inParams.scope)) {
      $missingRequiredInParams.push('\'scope\'');
    }
    if ($missingRequiredInParams.length) {
    }
    let $url = `${environment.backendUrl}api/`;
    
    const $options = {
    }
    
    const $body = $inParams;
    
    return this.$utils.http.post($url, $body, $options);
    
  }

}

